<div class="d-flex flex-column gap-3">
  <p>{{ confirmationText | translate }}</p>
  <p>{{ settingDescription | translate }}</p>
</div>
